import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuoteOpenIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "17",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14,15a1,1,0,0,1-1-1c0-5.39,3.8-7.58,5.8-8a1,1,0,0,1,.4,2C19,8,15,8.94,15,14A1,1,0,0,1,14,15Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "7",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,15a1,1,0,0,1-1-1C3,8.61,6.8,6.42,8.8,6a1,1,0,1,1,.4,2C9,8,5,8.94,5,14A1,1,0,0,1,4,15Z"
  })]
}), 'QuoteOpenIcon');